"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styles_1 = require("@material-ui/core/styles");
var useScrollTrigger_1 = __importDefault(require("@material-ui/core/useScrollTrigger"));
var Zoom_1 = __importDefault(require("@material-ui/core/Zoom"));
var ScrollTop = react_1.forwardRef(function ScrollTop(_a, ref) {
    var children = _a.children;
    var classes = useStyles();
    var trigger = useScrollTrigger_1.default({
        target: window || undefined,
        disableHysteresis: true,
        threshold: 100,
    });
    return (jsx_runtime_1.jsx(Zoom_1.default, __assign({ in: trigger }, { children: jsx_runtime_1.jsx("div", __assign({ role: "presentation", className: classes.root, ref: ref }, { children: children }), void 0) }), void 0));
});
exports.default = ScrollTop;
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
}); });
//# sourceMappingURL=ScrollToTop.js.map